import React from 'react';
import { Button as AntButton } from 'antd';
import {
  dsButtonDanger,
  dsButtonDisabledLink,
  dsButtonDisabledPrimary,
  dsButtonDisabledSecondary,
  dsButtonGhostBrand,
  dsButtonIcon,
  dsButtonLg,
  dsButtonLink,
  dsButtonPrimary,
  dsButtonSecondary,
  dsButtonSm,
  joinButtonClasses,
} from '../../../utils/buttonStyles';

const typeClassMap = {
  primary: dsButtonPrimary,
  danger: dsButtonDanger,
  link: dsButtonLink,
  default: dsButtonSecondary,
  dashed: dsButtonSecondary,
};

const sizeClassMap = {
  small: dsButtonSm,
  large: dsButtonLg,
};

const DSButton = ({ className = '', ghost = false, shape, size, type = 'default', children, ...props }) => {
  const variantClass = ghost && type === 'primary' ? dsButtonGhostBrand : (typeClassMap[type] || dsButtonSecondary);
  const iconOnlyClass = shape === 'circle' || (!children && props.icon) ? dsButtonIcon : '';
  const isInactive = props.disabled || props.loading;
  const disabledClass = !isInactive
    ? ''
    : type === 'link'
      ? dsButtonDisabledLink
      : (type === 'primary' || type === 'danger')
        ? dsButtonDisabledPrimary
        : dsButtonDisabledSecondary;

  return (
    <AntButton
      {...props}
      className={joinButtonClasses(variantClass, sizeClassMap[size], iconOnlyClass, disabledClass, className)}
      ghost={ghost}
      shape={shape}
      size={size}
      type={type}
    >
      {children}
    </AntButton>
  );
};

export default DSButton;
